// Enhanced image URL utility for high-resolution display
export const enhanceImageUrl = (url) => {
  if (!url) return url;
  
  // If it's already a Cloudinary URL, enhance it with quality parameters
  if (url.includes('cloudinary.com')) {
    // Extract the base URL and public ID
    const parts = url.split('/upload/');
    if (parts.length === 2) {
      const [baseUrl, pathPart] = parts;
      
      // Add high-quality transformation parameters
      const enhancements = 'dpr_2.0,f_auto,fl_immutable_cache,q_100';
      
      // Rebuild URL with enhancements
      return `${baseUrl}/upload/${enhancements}/${pathPart}`;
    }
  }
  
  return url;
};

// Get appropriate image size based on container
export const getImageSize = (containerWidth) => {
  if (containerWidth <= 400) return 'w_400';
  if (containerWidth <= 800) return 'w_800';
  if (containerWidth <= 1200) return 'w_1200';
  return 'w_1600';
};

// Enhanced image URL with size optimization
export const enhanceImageUrlWithSize = (url, containerWidth = 800) => {
  if (!url) return url;
  
  if (url.includes('cloudinary.com')) {
    const parts = url.split('/upload/');
    if (parts.length === 2) {
      const [baseUrl, pathPart] = parts;
      const sizeParam = getImageSize(containerWidth);
      const enhancements = `${sizeParam},dpr_2.0,f_auto,fl_immutable_cache,q_100`;
      return `${baseUrl}/upload/${enhancements}/${pathPart}`;
    }
  }
  
  return url;
};